import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  surface: {
    maxWidth: "280px",
    minWidth: "220px",
    width: "90%",
  },
});

const ErrorAlert = ({ message, onDismiss }: { message: string; onDismiss: () => void }) => {
  const styles = useStyles();

  if (!message) {
    return null;
  }

  return (
    <Dialog
      modalType="alert"
      open={true}
      onOpenChange={(_event, data) => {
        if (!data.open) {
          onDismiss();
        }
      }}
    >
      <DialogSurface className={styles.surface}>
        <DialogBody>
          <DialogTitle>Hello</DialogTitle>
          <DialogContent>{message}</DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onDismiss}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ErrorAlert;
